import {apiSlice} from '../apiSlice';

const DRIVER_URL = '/drivers';

export const driverApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getDriver: builder.query({
            query: (data) => ({
                url: `${DRIVER_URL}`,
                method: 'GET',
                headers: {
                    "x-access-token": data
                }
            })
        }),
        getDriverById: builder.query({
            query: ({token, id}) => ({
                url: `${DRIVER_URL}/${id}`,
                method: 'GET',
                headers: {
                    "x-access-token": token
                }
            })
        }),
        updateDriverById: builder.mutation({
            query: ({token, data, id}) => ({
                url: `${DRIVER_URL}/update/${id}`,
                method: 'PUT',
                body: data,
                headers: {
                    "x-access-token": token
                }
            })
        }),
        deleteDriverById: builder.mutation({
            query: ({token, id}) => ({
                url: `${DRIVER_URL}/delete/${id}`,
                method: 'DELETE',
                headers: {
                    "x-access-token": token
                }
            })
        }),
        newDriver: builder.mutation({
            query: ({token, data}) => ({
                url: `${DRIVER_URL}/new`,
                method: 'POST',
                body: data,
                headers: {
                    "x-access-token": token
                }
            })
        }),
    }),
});

export const {
    useGetDriverByIdQuery,
    useUpdateDriverByIdMutation,
    useDeleteDriverByIdMutation,
    useGetDriverQuery,
    useNewDriverMutation
} = driverApiSlice;
